import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { MovexBuilderRouteTransitionContext } from './context';

const MOVEX_BUILDER_TRANSITION_TIMEOUT_MS = 15000;

export const MovexBuilderRouteTransitionProvider = ({ children }) => {
  const [isNavigatingToMovexBuilder, setIsNavigatingToMovexBuilder] = useState(false);
  const transitionTimeoutRef = useRef(null);

  const clearTransitionTimeout = useCallback(() => {
    if (transitionTimeoutRef.current === null) {
      return;
    }

    window.clearTimeout(transitionTimeoutRef.current);
    transitionTimeoutRef.current = null;
  }, []);

  const completeMovexBuilderTransition = useCallback(() => {
    clearTransitionTimeout();
    setIsNavigatingToMovexBuilder(false);
  }, [clearTransitionTimeout]);

  const startMovexBuilderTransition = useCallback(() => {
    setIsNavigatingToMovexBuilder(true);
    clearTransitionTimeout();

    transitionTimeoutRef.current = window.setTimeout(() => {
      setIsNavigatingToMovexBuilder(false);
      transitionTimeoutRef.current = null;
    }, MOVEX_BUILDER_TRANSITION_TIMEOUT_MS);
  }, [clearTransitionTimeout]);

  useEffect(() => {
    return () => {
      clearTransitionTimeout();
    };
  }, [clearTransitionTimeout]);

  const contextValue = useMemo(
    () => ({
      isNavigatingToMovexBuilder,
      startMovexBuilderTransition,
      completeMovexBuilderTransition,
    }),
    [isNavigatingToMovexBuilder, startMovexBuilderTransition, completeMovexBuilderTransition]
  );

  return (
    <MovexBuilderRouteTransitionContext.Provider value={contextValue}>
      {children}
    </MovexBuilderRouteTransitionContext.Provider>
  );
};

export default MovexBuilderRouteTransitionProvider;
